// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Templates = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Templates = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Templates = _exports.Templates = function Templates(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.1654 13.959C14.0505 13.959 13.957 14.0525 13.957 14.1673V17.5007C13.957 17.8458 13.6772 18.1257 13.332 18.1257C12.9869 18.1257 12.707 17.8458 12.707 17.5007V14.1673C12.707 13.3621 13.3602 12.709 14.1654 12.709H17.4987C17.8439 12.709 18.1237 12.9888 18.1237 13.334C18.1237 13.6792 17.8439 13.959 17.4987 13.959H14.1654Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.16667 3.125C3.59101 3.125 3.125 3.59101 3.125 4.16667V15.8333C3.125 16.409 3.59101 16.875 4.16667 16.875H13.4767C13.7524 16.875 14.0176 16.7651 14.2131 16.5697L16.5706 14.2122C16.765 14.0178 16.875 13.7526 16.875 13.4767V4.16667C16.875 3.59101 16.409 3.125 15.8333 3.125H4.16667ZM1.875 4.16667C1.875 2.90066 2.90066 1.875 4.16667 1.875H15.8333C17.0993 1.875 18.125 2.90066 18.125 4.16667V13.4767C18.125 14.084 17.8834 14.6672 17.4544 15.0961L15.0969 17.4536C14.6674 17.8832 14.0843 18.125 13.4767 18.125H4.16667C2.90066 18.125 1.875 17.0993 1.875 15.8333V4.16667Z",
      fill: "#212B36"
    }));
  };
});
